export default __webpack_public_path__ + "static/media/mx.42c86b39.jpg";